
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/livescore/match/[id]",
      function () {
        return require("private-next-pages/livescore/match/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/livescore/match/[id]"])
      });
    }
  